import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const GoldCatalogueList = () => {
    const [goldCatalogues, setGoldCatalogues] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState('');
    const [subCategoryFilter, setSubCategoryFilter] = useState('');
    const [weightFilter, setWeightFilter] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch gold catalogues
        fetch(`${BASE_URL}goldCatalogue`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setGoldCatalogues(data.data); // Store the gold catalogues data
                } else {
                    alert('Error fetching gold catalogues');
                }
            })
            .catch(error => console.error('Error fetching gold catalogues:', error));

        // Fetch categories
        fetch(`${BASE_URL}categories`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setCategories(data.data); // Store categories data
                } else {
                    alert('Error fetching categories');
                }
            })
            .catch(error => console.error('Error fetching categories:', error));

        // Fetch subcategories
        fetch(`${BASE_URL}subcategories`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setSubCategories(data.data); // Store subcategories data
                } else {
                    alert('Error fetching subcategories');
                }
            })
            .catch(error => console.error('Error fetching subcategories:', error));
    }, []);

    // Filter catalogues based on filters
    const filteredCatalogues = goldCatalogues.filter(catalogue => {
        const matchesCategory = categoryFilter ? catalogue.category_id === parseInt(categoryFilter) : true;
        const matchesSubCategory = subCategoryFilter ? catalogue.sub_category_id === parseInt(subCategoryFilter) : true;
        const matchesWeight = weightFilter ? catalogue.weight === parseFloat(weightFilter) : true;
        return matchesCategory && matchesSubCategory && matchesWeight;
    });

    const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.text('Gold Catalogue List', 14, 10);

        const tableData = filteredCatalogues.map(catalogue => [
            catalogue.id,
            getCategoryName(catalogue.category_id),
            getSubCategoryName(catalogue.sub_category_id),
            catalogue.image ? `${BASE_URL}${catalogue.image}` : 'No Image',
            catalogue.weight,
            catalogue.price,
            new Date(catalogue.created_at).toLocaleString(),
            new Date(catalogue.updated_at).toLocaleString(),
        ]);

        doc.autoTable({
            head: [['ID', 'Category', 'Subcategory', 'Image', 'Weight', 'Price', 'Created At', 'Updated At']],
            body: tableData,
        });

        doc.save('gold_catalogue_list.pdf');
    };

    const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredCatalogues.map(catalogue => ({
            ID: catalogue.id,
            Category: getCategoryName(catalogue.category_id),
            SubCategory: getSubCategoryName(catalogue.sub_category_id),
            Image: catalogue.image ? `${BASE_URL}${catalogue.image}` : 'No Image',
            Weight: catalogue.weight,
            Price: catalogue.price,
            CreatedAt: new Date(catalogue.created_at).toLocaleString(),
            UpdatedAt: new Date(catalogue.updated_at).toLocaleString(),
        })));


        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Gold Catalogue List");

        XLSX.writeFile(workbook, 'gold_catalogue_list.xlsx');
    };

    const getCategoryName = (categoryId) => {
        const category = categories.find(cat => cat.id === categoryId);
        return category ? category.name : 'Unknown';
    };

    const getSubCategoryName = (subCategoryId) => {
        const subCategory = subCategories.find(sub => sub.id === subCategoryId);
        return subCategory ? subCategory.name : 'Unknown';
    };

    const handleEdit = (id) => {
        navigate(`/EditGoldCatalogue/${id}`);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this gold catalogue?")) {
            fetch(`${BASE_URL}goldCatalogue/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setGoldCatalogues(goldCatalogues.filter(catalogue => catalogue.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting gold catalogue:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Gold Catalogue List</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        {/* Category Filter */}
                                        {/* <select
                                            className="form-select"
                                            value={categoryFilter}
                                            onChange={(e) => setCategoryFilter(e.target.value)}
                                        >
                                            <option value="">All Categories</option>
                                            {categories.map(category => (
                                                <option key={category.id} value={category.id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </select> */}

                                        {/* SubCategory Filter */}
                                        <select
                                            className="form-select"
                                            value={subCategoryFilter}
                                            onChange={(e) => setSubCategoryFilter(e.target.value)}
                                        >
                                            <option value="">All Subcategories</option>
                                            {subCategories.map(subCategory => (
                                                <option key={subCategory.id} value={subCategory.id}>
                                                    {subCategory.name}
                                                </option>
                                            ))}
                                        </select>

                                        {/* Weight Filter */}
                                        <input
                                            type="number"
                                            className="form-control mt-3"
                                            value={weightFilter}
                                            onChange={(e) => setWeightFilter(e.target.value)}
                                            placeholder="Filter by Weight"
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/AddGoldCatalogue')}>Add Gold Catalogue</button>
                                        <button className="btn btn-secondary ms-2" onClick={handleExportPDF}>Export to PDF</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Subcategory</th>
                                                <th>Image</th>
                                                <th>Weight</th>
                                                {/* <th>Price</th> */}
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredCatalogues.map(catalogue => (
                                                <tr key={catalogue.id}>
                                                    <td>{catalogue.id}</td>
                                                    <td>{getSubCategoryName(catalogue.sub_category_id)}</td>
                                                    <td>
                                                        <img
                                                            src={`${BASE_URL}${catalogue.image}`}
                                                            alt={catalogue.id}
                                                            width="100"
                                                            height="100"
                                                        />
                                                    </td>
                                                    <td>{catalogue.weight}</td>
                                                    {/* <td>{catalogue.price}</td> */}
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(catalogue.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(catalogue.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default GoldCatalogueList;
